<template>
  <v-container>
    <v-card-text v-if="!data">
      <v-container class="text-center">
        <v-progress-circular
          indeterminate
        ></v-progress-circular>
      </v-container>
    </v-card-text>
    <v-card-text v-if="data && !data.totp_verified">
      <v-container>
        <v-row>
          <v-col cols="6">
            <v-img :width="300" :src="data.qr"></v-img>
          </v-col>
          <v-col cols="6">
            <v-text-field
              :label="$t('totp')"
              v-model="editedItem.totp"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            {{$t('scan_and_submit_totp')}}
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-text v-if="data && data.totp_verified">
      <v-container class="text-center">
        {{$t('totp_verified')}}
      </v-container>
    </v-card-text>
    <v-card-actions v-if="data && !data.totp_verified">
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        :loading="busy"
        @click="verifyTotp"
      >
        {{$t('submit')}}
      </v-btn>
    </v-card-actions>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import {mapGetters} from 'vuex'

  export default {
    name: 'setuptotp',
    computed: {
      ...mapGetters({
        user: 'auth/user',
        isClient: 'auth/isClient',
        isClientCsa: 'auth/isClientCsa',
      }),
    },
    mounted () {
      this.fetch();
    },
    data: function () {
      return {
        busy: false,
        data: null,
        editedItem: {
          totp: '',
        },
        defaultItem: {
          totp: '',
        }
      }
    },
    methods: {
      getUserEffUrl() {
        return this.isClient || this.isClientCsa ? 'client' : 'user';
      },
      fetch() {
        axios
          .get(
            `/app/api/${this.getUserEffUrl()}/${this.user.user_id}/gettotpqr`
          )
          .then((response) => {
            this.data = response.data.data;
          })
          .catch((error) => {
            this.$store.dispatch('snackbar/openSnackbar', {
              message: error.response.data.message,
              color: 'error',
            });
          });
      },
      verifyTotp() {
        if (!this.editedItem.totp) {
          return;
        }
        
        this.busy = true;

        axios.post(
          `/app/api/${this.getUserEffUrl()}/${this.user.user_id}/verifytotp`, 
          { totp: this.editedItem.totp }
        )
          .then(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.data = null;

            this.$store.dispatch('snackbar/openSnackbar', {
              message: this.$t('success'),
              color: 'success',
            });

            this.fetch();
          })
          .catch((error) => {
            this.$store.dispatch('snackbar/openSnackbar', {
              message: error.response.data.message,
              color: 'error',
            })
          })
          .finally(() => {
            this.busy = false;
          })
      },
    },
  }
</script>
